import { Layout } from './layout';
import { Loading } from './loading';

export function ExpiringDomainsAssociatedWithAgreementsWidgetLoading() {
  return (
    <Layout>
      <Loading />
    </Layout>
  );
}
